import { common } from './i18n/common'
import { home } from './i18n/home'
import { services } from './i18n/services'
import { serviceDetails } from './i18n/serviceDetails'
import { portfolio } from './i18n/portfolio'
import { reviews } from './i18n/reviews'
import { faq } from './i18n/faq'
import { process as processCopy } from './i18n/process'
import { about } from './i18n/about'
import { contact } from './i18n/contact'

export type Lang = 'en' | 'es'

function build(lang: Lang) {
  return {
    common: common[lang],
    home: home[lang],
    services: services[lang],
    serviceDetails: serviceDetails[lang],
    portfolio: portfolio[lang],
    reviews: reviews[lang],
    faq: faq[lang],
    process: processCopy[lang],
    about: about[lang],
    contact: contact[lang],
  }
}

export type Content = ReturnType<typeof build>

export const content: Record<Lang, Content> = { en: build('en'), es: build('es') }
